// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"h7","input":"h8","button":"h9"};